import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { SetDirtyForm } from "../_store/navigation/navigation.actions";

export interface SelfAssessmentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: "root",
})
export class SelfAssessmentGuard implements CanDeactivate<SelfAssessmentDeactivate>
{
  constructor(
    private store: Store
  ){}

  public dirty: boolean = false;
  public isComplete: boolean = false;
  public activity: Subject<void> = new Subject<void>();
  public cancelled: Subject<boolean> = new Subject<boolean>();
  message: string = $localize`:@@confirm-message-alert:You have not finished but you can carry on later.\nAre you sure you wish to leave now?\nSelect OK to leave, or Cancel to carry on now.`;
  
  canDeactivate(component: SelfAssessmentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    if(component) {
      this.store.dispatch(SetDirtyForm({value: this.dirty}));
      if (!this.isComplete && this.dirty){
        this.activity.next();
        let response = confirm(this.message);
        this.cancelled.next(!response);
        return response;
      };
      return true;
    }
    return true;
  }
}
